import React, { useEffect, useState } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { api_url } from "../config/config";

const VendorProductStatus = () => {
    const [vendorProducts, setVendorProducts] = useState([]);
    const [search, setSearch] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const navigate = useNavigate();

    // Fetch all vendor products
    const fetchProductStatus = async () => {
        try {
            const res = await axios.get(`${api_url}/employee/action`, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: "Bearer " + localStorage.getItem("admin_token"),
                },
            });
            setVendorProducts(res.data.data);
        } catch (e) {
            toast.error("Failed to fetch product status.");
        }
    };

    useEffect(() => {
        fetchProductStatus();
    }, []);

    const handleResetFilters = () => {
        setSearch("");
        setStartDate("");
        setEndDate("");
    };

    const handleViewReason = (product) => {
        setSelectedProduct(product);
        setShowReasonModal(true);
    };

    const handleEditProduct = () => {
        if (selectedProduct?.product_id) {
            navigate(`/ng-admin/edit-product/${selectedProduct.product_id}`);
        } else {
            toast.error("Product ID not available.");
        }
    };

    const filteredProducts = vendorProducts.filter((product) => {
        const createdDate = new Date(product.created_at);
        const matchSearch =
            product.name?.toLowerCase().includes(search.toLowerCase()) ||
            product.product_code?.toLowerCase().includes(search.toLowerCase());
        const matchStart = startDate ? createdDate >= new Date(startDate) : true;
        const matchEnd = endDate ? createdDate <= new Date(endDate) : true;
        return matchSearch && matchStart && matchEnd;
    });

    return (
        <div className="container mx-auto p-4">
            <ToastContainer />
            <h1 className="text-2xl font-bold mb-4 text-center">
                Employee Product Status
            </h1>

            {/* Filters */}
            <div className="flex flex-wrap gap-4 mb-4 items-center justify-center">
                <input
                    type="text"
                    placeholder="Search by name or code"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="border px-3 py-2 rounded w-64"
                />
                <input
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="border px-3 py-2 rounded"
                    max={new Date().toISOString().split("T")[0]}
                />
                <input
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="border px-3 py-2 rounded"
                    max={new Date().toISOString().split("T")[0]}
                />
                <button
                    onClick={handleResetFilters}
                    className="bg-gray-200 px-4 py-2 rounded hover:bg-gray-300"
                >
                    Reset Filters
                </button>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="table-auto w-full border-collapse border border-gray-200">
                    <thead>
                        <tr className="bg-gray-100 text-left">
                            <th className="border p-2">Product Name</th>
                            <th className="border p-2">Product Code</th>
                            <th className="border p-2">Created Date</th>
                            <th className="border p-2">Updated Date</th>
                            <th className="border p-2">Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredProducts.length > 0 ? (
                            filteredProducts.map((product) => (
                                <tr
                                    key={product.id}
                                    className="text-start hover:bg-gray-100 transition duration-150"
                                >
                                    <td className="border p-2">{product.name}</td>
                                    <td className="border p-2">{product.product_code}</td>
                                    <td className="border p-2">
                                        {new Date(product.created_at).toLocaleDateString()}
                                    </td>
                                    <td className="border p-2">
                                        {new Date(product.updated_at).toLocaleDateString()}
                                    </td>
                                    <td className="border p-2">
                                        <span
                                            className={`font-semibold rounded-full px-4 py-1 inline-block ${
                                                product.status === "approved"
                                                    ? "bg-green-100 text-green-600"
                                                    : product.status === "rejected"
                                                    ? "bg-red-100 text-red-600"
                                                    : "bg-yellow-100 text-yellow-600"
                                            }`}
                                        >
                                            {product.status.charAt(0).toUpperCase() + product.status.slice(1)}
                                        </span>
                                        {product.status === "rejected" && (
                                            <button
                                                onClick={() => handleViewReason(product)}
                                                className="ml-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                                            >
                                                View
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="5" className="text-center p-4 text-gray-500">
                                    No products match your filter.
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Modal for Rejection Reason */}
            {showReasonModal && selectedProduct && (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
        <div className="bg-white p-6 rounded shadow-md w-full max-w-md relative">
            <h2 className="text-xl font-semibold mb-4">
                Rejection Reason
            </h2>
            <textarea
                className="w-full border rounded p-2"
                rows={4}
                value={selectedProduct.reject_reason || "No reason provided."}
                readOnly
            />
            <div className="flex justify-end gap-2 mt-4">
                <button
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                    onClick={() => setShowReasonModal(false)}
                >
                    Close
                </button>
                <button
                    onClick={handleEditProduct}
                    title="Edit Product"
                    className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
                >
                    Go To Correction
                </button>
            </div>
        </div>
    </div>
)}

        </div>
    );
};

export default VendorProductStatus;
